<template>
  <div class="absolute inset-y-0 end-0 flex items-center pe-3 text-wt-red-d">
    <i class="fa-solid fa-circle-exclamation"></i>
  </div>
</template>
